import * as React from 'react';

import { SaveFooterOptions } from 'src/components/resourceDialog/DialogFooter';
import {
  BaseDialogContextType,
  createBaseDialogContextDefaults,
  useBaseDialogContextValue,
} from 'src/containers/shared/useBaseDialogContext';
import * as copy from 'src/templates/copy';
import { FilePreviewMetadata } from 'src/types/fileUpload';

export type FooterOptions = SaveFooterOptions;

export type ProjectFileUploadPreviewDialogContextType =
  BaseDialogContextType<FooterOptions> & {
    // File upload state
    fileMetadata: FilePreviewMetadata | null;
    setFileMetadata: (metadata: FilePreviewMetadata | null) => void;
    isFileReplaced: boolean;
    setIsFileReplaced: (isReplaced: boolean) => void;
  };

export const ProjectFileUploadPreviewDialogContext =
  React.createContext<ProjectFileUploadPreviewDialogContextType>({
    ...createBaseDialogContextDefaults<FooterOptions>(),
    fileMetadata: null,
    setFileMetadata: () => {},
    isFileReplaced: false,
    setIsFileReplaced: () => {},
  });

export const useProjectFileUploadPreviewDialog = () => {
  return React.useContext(ProjectFileUploadPreviewDialogContext);
};

export const useProjectFileUploadPreviewDialogContextValue = () => {
  const {
    fullSize,
    setFullSize,
    dialogTitle,
    setDialogTitle,
    headerBackButton,
    setHeaderBackButton,
    isLoading,
    setIsLoading,
    footerOptions,
    setFooterOptions,
  } = useBaseDialogContextValue<FooterOptions>(
    copy.components.fileUploadPreviewDialog.title
  );

  const [fileMetadata, setFileMetadata] =
    React.useState<FilePreviewMetadata | null>(null);
  const [isFileReplaced, setIsFileReplaced] = React.useState(false);

  return React.useMemo(
    () => ({
      fullSize,
      setFullSize,
      dialogTitle,
      setDialogTitle,
      headerBackButton,
      setHeaderBackButton,
      isLoading,
      setIsLoading,
      footerOptions,
      setFooterOptions,
      fileMetadata,
      setFileMetadata,
      isFileReplaced,
      setIsFileReplaced,
    }),
    [
      fullSize,
      setFullSize,
      dialogTitle,
      setDialogTitle,
      headerBackButton,
      setHeaderBackButton,
      isLoading,
      setIsLoading,
      footerOptions,
      setFooterOptions,
      fileMetadata,
      isFileReplaced,
    ]
  );
};
